module.exports = __webpack_public_path__ + "img/item1.b18ed215.png";